<template>
  <div class="w-full h-full" id="clip">
    <div class="h-full">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="18">
          <el-checkbox-group v-model="clipList" class="pl-10px" @change="onChange">
            <el-checkbox label="包围盒"></el-checkbox>
            <el-checkbox label="操作轴"></el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
      <div class="h-[calc(100%-60px)] text-14px p-5px pt-10px">
        <el-row type="flex" align="middle" justify="space-between">
          <el-col :span="6" class="text-white"
            ><i class="el-icon-document mr-5px"></i>{{ currentComponent | clipNameFilter }}</el-col
          >
          <el-col :span="9">
            <el-input
              @keyup.enter.native="getClipRecordList('referch')"
              size="small"
              clearable
              placeholder="请输入内容"
              v-model.trim="params.KeyWords"
            ></el-input
          ></el-col>
          <el-col :span="3">
            <el-tooltip content="搜索" placement="top" :open-delay="1000">
              <el-button
                :disabled="isloading"
                type="primary"
                @click="getClipRecordList('referch')"
                size="mini"
                icon="el-icon-search"
                class="ml-5px"
              ></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" size="mini" @click="openClipDialog('')">保存剖切</el-button>
          </el-col>
        </el-row>
        <el-row class="overflow-y-auto mt-5px h-[calc(100%-32px)]" v-loading="isloading">
          <div class="mb-10px" v-for="(item, index) in clipRecordList" :key="index">
            <img
              :src="item.imageContent"
              alt=""
              @click="viewItem(item)"
              class="tab-item-img align-top h-130px w-full rounded-5px"
            />
            <div
              class="tab-item-title flex text-white py-2px px-5px justify-between bg-[#46a6ff9c] h-25px"
            >
              <div>
                <span>{{ item.seqNo }}</span>
                <span class="pl-5px pr-5px text-12px">{{ item.fileName }}</span>
                <el-tooltip content="编辑" placement="top" :open-delay="1000">
                  <i class="el-icon-edit" @click="openClipDialog(item)"></i>
                </el-tooltip>
              </div>
              <div>
                <el-tooltip content="删除" placement="top" :open-delay="1000">
                  <i @click="deleteItem(item.id)" class="el-icon-delete"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <p class="text-center text-white mt-20px" v-if="!clipRecordList.length">暂无数据！</p>
        </el-row>
      </div>
      <div class="text-right mt-10px">
        <el-pagination
          background
          @size-change="getClipRecordList('referch')"
          @current-change="getClipRecordList"
          :current-page.sync="params.PageNo"
          :page-size.sync="params.PageSize"
          layout="total, prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
    <CockpitDialog
      class="fixed top-200px left-666px w-565px h-400px"
      v-if="clipDialogShow"
      :title="isAdd ? '新增剖切' : '编辑剖切'"
      @close="close"
    >
      <div class="m-5px" v-loading="convertToImageLoading" element-loading-text="快照生成中">
        <div class="w-500px mr-20px mt-20px">
          <el-form :model="clipForm" label-width="80px" :rules="clipRules" ref="addEditForm">
            <el-form-item label="序号" prop="seqNo">
              <el-input v-model.trim="clipForm.seqNo" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="剖切方式">
              <el-input
                disabled
                :value="currentComponent | clipNameFilter"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="文件名称" prop="fileName">
              <el-input v-model="clipForm.fileName" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="w-550px h-40px mt-60px ml-190px">
          <el-button @click="close" size="small">取 消</el-button>
          <el-button type="primary" @click="submitClip" size="small">确 定</el-button>
        </div>
      </div>
    </CockpitDialog>
    <img :src="imgChangeUrl" alt="" class="mt-800px" id="rotateImg" v-if="true" />
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { ThreeDimensionalSectioningApi } from '@wiz-api/cloud-render-management'
import { FileApi } from '@wiz-api/file-management'
import CockpitDialog from '../../../../components/cockpit/CockpitDialog'
import { isJSONObj } from '../../assets/js/scene/scene'
// import { cilpSetting, cancelClip, updateAxis } from '../js/clip'
const threeDimensionalSectioningApi = new ThreeDimensionalSectioningApi()
const fileApi = new FileApi()
export default {
  name: 'ClipTool',
  components: {
    CockpitDialog,
  },
  props: {
    currentComponent: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    const checkSeq = (rules, value, callback) => {
      if (!_.isSafeInteger(_.toNumber(value))) {
        callback(new Error('序号必须为整数类型'))
      } else {
        callback()
      }
    }
    return {
      convertToImageLoading: false,
      clipList: ['包围盒', '操作轴'],
      clipRecordList: [],
      params: {
        PageSize: 5,
        PageNo: 1,
        KeyWords: '',
        SiteId: '',
        SectioningType: '',
        DocumentFileId: '',
      },
      pageTotal: 10,
      clipDialogShow: false, // 保存或者编辑剖切弹框显示与否
      isAdd: true, // 是否是新增操作
      isloading: false, // 是否正在加载中
      clipForm: {
        seqNo: '',
        fileName: '',
        sectioningType: '',
        imgUrl: '',
        documentFileId: '',
        content: '',
        screenshotAttachmentId: '',
        siteId: '',
      },
      clipObjParams: {
        // 存在刨切的数据
        clipData: '',
        clipObjCodes: [],
      },
      clipEnumList: {
        // 剖切枚举
        AllClip: 1,
        PartClipBox: 2,
        ThreePanel: 3,
      },
      imgChangeUrl: '', // 截图翻转之前的路径
      showTemporaryImg: false, // 临时展示的翻转后的模型截图
      clipRules: {
        seqNo: [
          { required: true, message: '请输入内容', trigger: 'change' },
          { required: true, validator: checkSeq, trigger: 'change' },
        ],
        fileName: [{ required: true, message: '请输入内容', trigger: 'change' }],
      },
    }
  },
  created() {},
  filters: {
    clipNameFilter(val) {
      switch (val) {
        case 'AllClip':
          return '全局剖切'
        case 'PartClipBox':
          return '局部剖切'
        default:
          return '三面剖切'
      }
    },
  },
  watch: {
    currentComponent: {
      handler(val) {
        if (val) {
          this.getClipRecordList('referch')
          this.setClip(val)
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.cloudRender.Clip.cancelClip()
  },
  methods: {
    // 设置剖切
    async setClip(val) {
      let currentNode = null
      let clipDataType = 2
      const clipNode = await this.cloudRender.NodeProxy.getRoot()
      const currentRoot = _.find(clipNode.data, (el) => {
        return (
          el.nodeInfo &&
          el.nodeInfo.code &&
          isJSONObj(el.nodeInfo.code) &&
          JSON.parse(el.nodeInfo.code).type === 'Root'
        )
      })
      // if (this.clipEnumList[val] === 2 || this.clipEnumList[val] === 3) {
      //   const selectNode = await this.cloudRender.NodeProxy.getSelectedItem()
      //   clipDataType = selectNode && selectNode.status && selectNode.data ? 3 : 2
      //   currentNode =
      //     selectNode && selectNode.status && selectNode.data ? selectNode.data : currentRoot
      // } else {
      //   currentNode = currentRoot
      // }
      if (this.clipEnumList[val]) {
        const selectNode = await this.cloudRender.NodeProxy.getSelectedItem()
        clipDataType = selectNode && selectNode.status && selectNode.data ? 3 : 2
        currentNode =
          selectNode && selectNode.status && selectNode.data ? selectNode.data : currentRoot
      }
      const options = {
        setIsInside: this.clipEnumList[val] === 3,
        setPartCilp: this.clipEnumList[val] === 2 && clipDataType === 3,
      }
      this.$set(options, clipDataType === 2 ? 'node' : 'item', currentNode)
      const res = await this.cloudRender.Clip.createClip(
        clipDataType,
        this.clipEnumList[val] === 3 ? 3 : 0,
        options
      )
    },
    async getImageContent(id) {
      // 获取图片内容
      const [error, result] = await fileApi.getPublicImageBaseString(id)
      if (!error) {
        return `data:image/png;base64,${result.base64}`
      }
      return ''
    },
    // 查看每一项的剖切状态
    async viewItem(item) {
      await this.cloudRender.Clip.cancelClip()
      // 移动相机
      const contentObj = JSON.parse(item.content)
      const cameraLocation = contentObj.cameraLocation
      this.cloudRender.Camera.moveCamera('CameraParam', cameraLocation)
      const options = {
        setIsInside: item.sectioningType === 3,
        setPartCilp: false,
        clipData: contentObj.clipData,
      }
      this.cloudRender.Clip.createClip(4, item.sectioningType === 3 ? 3 : 0, options)
    },
    // 获取记录列表
    async getClipRecordList(type) {
      this.isloading = true
      this.params.DocumentFileId = this.customProps.sceneId
      this.params.SectioningType = this.clipEnumList[this.currentComponent]
      if (type === 'referch') {
        this.params.PageNo = 1
      }
      this.clipRecordList = []
      const [err, res] = await threeDimensionalSectioningApi.queryList({
        documentFileId: this.params.DocumentFileId,
        sectioningType: this.params.SectioningType,
        sorting: 'seqNo',
        skipCount: (this.params.PageNo - 1) * this.params.PageSize, // Number |
        maxResultCount: this.params.PageSize, // Number |
      })
      if (!err && res) {
        this.clipRecordList = res.items
        _.forEach(this.clipRecordList, async (item) => {
          const imgRes = await this.getImageContent(item.screenshotAttachmentId)
          this.$set(item, 'imageContent', imgRes)
        })
        this.pageTotal = res.totalCount
      } else {
        this.pageTotal = 0
      }
      this.isloading = false
    },
    // 打开保存或编辑当前剖切记录弹框
    async openClipDialog(val) {
      this.convertToImageLoading = true
      this.clipForm.sectioningType = this.clipEnumList[this.currentComponent]
      this.clipDialogShow = true
      this.isAdd = !val
      if (val) {
        this.clipForm.fileName = val.fileName
        this.clipForm.seqNo = val.seqNo
        this.clipForm.id = val.id
        // return
      }
      // 新增操作时，截图操作
      const captureDom = document.querySelector('#playerEngineId')
      this.showTemporaryImg = true
      this.imgChangeUrl = await this.getConvertToImage(captureDom)
      setTimeout(async () => {
        const captureDomAfter = document.querySelector('#rotateImg')
        this.clipForm.imgUrl = await this.getConvertToImage(captureDomAfter)
        this.convertToImageLoading = false
        this.showTemporaryImg = false
      }, 0)
      // 新增时获取刨切数据包
      this.clipObjParams = this.$options.data().clipObjParams
      const res = await this.cloudRender.Clip.getClipData()
      if (res && res.status && res.data) {
        this.clipObjParams.clipData = res.data
      }
    },
    // 获取截图后的快照
    getConvertToImage(container, options = {}) {
      // 获取指定的宽高
      const width = parseInt(window.getComputedStyle(container).width, 10)
      const height = parseInt(window.getComputedStyle(container).height, 10)
      // // html2canvas配置项
      const ops = {
        width,
        height,
        useCORS: true,
        allowTaint: true,
        ...options,
        dpi: 300,
      }
      return html2canvas(container, ops).then((canvas) => {
        return canvas.toDataURL('image/png')
      })
    },
    // 图片转文件
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    // 关闭弹框
    close() {
      this.clipDialogShow = false
      this.clipForm = this.$options.data().clipForm
      this.$refs.addEditForm.resetFields()
    },
    // 弹框确定操作
    submitClip() {
      this.$refs.addEditForm.validate(async (valid) => {
        if (valid) {
          // 摄像头位置
          const cameraData = await this.cloudRender.Camera.getCurrentCamera()
          this.clipObjParams.cameraLocation = cameraData.data || {}
          this.clipForm.content = JSON.stringify(this.clipObjParams)
          // 新增操作
          // 剖切截图上传
          const file = await this.dataURLtoFile(this.clipForm.imgUrl, `${this.generateUUID()}.png`)
          const [err, res] = await fileApi.upload({
            files: [file],
            authLevel: 2,
          })
          if (this.isAdd) {
            if (!err && res && res.length) {
              const query = {
                content: this.clipForm.content,
                screenshotAttachmentId: res[0].id, // 截图文件id
                fileName: this.clipForm.fileName,
                documentFileId: this.customProps.sceneId,
                sectioningType: this.clipForm.sectioningType,
                seqNo: this.clipForm.seqNo,
              }
              const [error, result] = await threeDimensionalSectioningApi.create({ body: query })
              if (!error && result) {
                this.$message.success('新增成功！')
              }
            }
          } else {
            // 编辑操作
            const [errorEdit, resultEdit] = await threeDimensionalSectioningApi.update(
              this.clipForm.id,
              {
                body: {
                  content: this.clipForm.content,
                  screenshotAttachmentId: res[0].id, // 截图文件id
                  fileName: this.clipForm.fileName,
                  documentFileId: this.customProps.sceneId,
                  sectioningType: this.clipForm.sectioningType,
                  seqNo: this.clipForm.seqNo,
                  id: this.clipForm.id,
                },
              }
            )
            if (!errorEdit && resultEdit) {
              this.$message.success('编辑成功！')
            }
          }
          this.getClipRecordList()
          this.clipDialogShow = false
        }
      })
    },
    // 删除操作
    async deleteItem(val) {
      const [err, res] = await threeDimensionalSectioningApi.callDelete_0(val)
      if (!err) {
        this.$message.success('删除成功！')
        this.getClipRecordList('referch')
      }
    },
    // 生成uuid
    generateUUID() {
      let d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
    onChange() {
      this.cloudRender.Clip.setVisible(['Panel'], this.clipList.includes('包围盒'))
      this.cloudRender.Clip.setVisible(['Axis'], this.clipList.includes('操作轴'))
    },
  },
}
</script>
<style lang="scss" scoped>
#rotateImg {
  transform: rotateX(180deg);
}

.tab-item-title {
  border-radius: 0 0 5px 5px;
}

.tab-item-img {
  border-radius: 5px 5px 0 0;
}

::v-deep .el-form-item__content {
  margin-right: 30px !important;
  margin-left: 80px !important;
}

::v-deep .el-loading-mask {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
</style>
